import * as React from 'react'

import { Button } from '~/client/src/shared/components/Button/Button'
import {
  ListSelector,
  type ListSelectorTitleVariant,
} from '~/client/src/shared/components/ListSelector/ListSelector'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  title: string
  onClose: () => void
  titleVariant?: ListSelectorTitleVariant
}

const EmptyTemplatesState: React.FC<IProps> = ({
  title,
  onClose,
  titleVariant,
}) => (
  <div className="tw:flex tw:flex-col tw:flex-1 tw:min-h-0">
    <ListSelector.Title
      title={title}
      onClose={onClose}
      variant={titleVariant}
    />
    <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:flex-1 tw:px-6 tw:py-12 tw:gap-3">
      <div className="tw:text-title-sm tw:text-foreground tw:text-center">
        {Localization.translator.noFormsAvailable}
      </div>
      <div className="tw:text-body-md tw:text-muted-foreground tw:text-center">
        {Localization.translator.askAdminToCreateForm}
      </div>
      <Button variant="outline" size="lg" onClick={onClose}>
        {Localization.translator.close}
      </Button>
    </div>
  </div>
)

export default EmptyTemplatesState
